import { type EditorValue, parseDraftString } from '@octopus-do/octopus-editor'
import type { ID, MonolithicBlock } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

export const useMonolithicData = (id: ID) => {
  const { content, title, colorId } = useSelector(
    migrationProjectSelector.getProjectBlockUnsafe(id)
  ) as MonolithicBlock

  const color = useSelector(migrationProjectSelector.getColorById(colorId))

  //todo: support multiple content types in core
  const value =
    typeof content === 'string'
      ? parseDraftString(content)
      : (content as unknown as EditorValue)

  return {
    title,
    content: value,
    color: color?.hexCode || '#2F7FEF',
  }
}
